<script lang="ts" setup>
	import { type NavBarItem } from '../../../../types'
	const props = defineProps<{
		navBar?: {
			items: NavBarItem[]
			slot?: 'center'|'right'
			vertical?: Object
			horizontal?: Object
		},
		resizeOnScroll?: {
			yPos?: number
			height: string
		}
	}>()
	const attrs = ref()

	const navBar = computed(() => {
		if (!props.navBar)
			return false
		let navBar = {...props.navBar}
		if (!navBar.slot || navBar.slot === 'center') {
			navBar.slot = 'default'
		}
		return navBar
	})

	onMounted(() => {
		const h = getCssVariable('--ui-header-height')
		document.documentElement.style.setProperty('--ui-header-height', h)
		if (import.meta.browser) {
			const h = getCssVariable('--ui-header-height')
			const sh = props.yPos || 10
			if (props.resizeOnScroll) {
				addEventListener('scroll', (e: Event) => {
					if(window.pageYOffset > sh && h !== props.resizeOnScroll.height) {
						document.documentElement.style.setProperty('--ui-header-height', props.resizeOnScroll.height)
						attrs.value = {'data-small': true}

					}
					else if (window.pageYOffset <= sh && h !== props.resizeOnScroll.height) {
						document.documentElement.style.setProperty('--ui-header-height', h)
						attrs.value = undefined
					}
				});
			}
		}
	})
</script>
<template>
	<UHeader as="div" class="transition-all [&_[data-slot=title]_img]:transition-all duration-200 ease-in-out group" v-bind="attrs">
		<template v-if="navBar" #body>
			<slot name="body-prepend" />
			<slot name="body">
				<UNavigationMenu :items="navBar.items" orientation="vertical" v-bind="navBar.vertical ?? {}" />
			</slot>
			<slot name="body-append" />
		</template>

		<template v-if="navBar" v-slot:[navBar.slot]>
			<slot :name="navBar.slot+'-prepend'" />
			<slot :name="navBar.slot">
				<GsNavBar :items="navBar.items" v-bind="navBar.horizontal ?? {}" />
			</slot>
			<slot :name="navBar.slot+'-append'"></slot>
		</template>

		<template
			v-for="(_, slotName) in $slots"
			:key="slotName"
			:slot="slotName"
			v-slot:[slotName]="slotProps"
		>

			<slot v-if="slotName !== navBar.slot" :name="slotName" v-bind="slotProps ?? {}"/>
		</template>
	</UHeader>
</template>
